export { default, ErrorBoundaryWrapper, withErrorBoundary } from './ErrorBoundary'
export type { ErrorBoundaryWrapperProps, ErrorDetails } from './ErrorBoundary'
